<div
  class="bg-[#FFE6DC] bg-[url('./assets/sell-with-us/swiper-bg.png')] bg-no-repeat bg-[right_20%]"
>
  <div class="pt-20 md:pt-28 ">
    <div class="flex flex-col justify-between">
      <div class="mb-10 container">
        <h2 class="text-black max-w-[500px] rfs:text-4xl">
          {{ "sell-with-us.listing-swiper-section.title" | transloco }}
        </h2>
      </div>
      <div class="swiper w-[95%] h-[900px] md:h-[644px] max-md:container">
        <div class="swiper-wrapper">
          @for (item of swiperItems; track item; let i = $index) {
          <div class="swiper-slide">
            <div
              class="grid grid-cols-1 md:grid-cols-2 items-center h-full gap-5"
            >
              <div class="h-full content-end md:justify-items-center order-2 md:order-1">
                <img
                  src="./assets/sell-with-us/swiper-phone-{{ i + 1 }}-{{
                    lang
                  }}.png"
                />
              </div>
              <div class="order-1 md:order-2 pt-5">
                <div class="max-w-[400px]">
                  <div class="mb-8">
                    <img src="./assets/sell-with-us/0{{ i + 1 }}.png" />
                  </div>
                  <h4 class="text-black rfs:text-3xl mb-6">
                    {{ item.title | transloco }}
                  </h4>
                  <p class="text-gray-700">
                    {{ item.description | transloco }}
                  </p>
                </div>
              </div>
            </div>
          </div>
          }
        </div>
      </div>
    </div>
  </div>
</div>
